// extracted by mini-css-extract-plugin
module.exports = {"menu-wrp":"CategoryItem_menu-wrp__2fktK","menu-item":"CategoryItem_menu-item__2VIgD","loading":"CategoryItem_loading__NqK1M","wait":"CategoryItem_wait__2c_Fo"};